import { render, staticRenderFns } from "./SelfUser.vue?vue&type=template&id=b8167446"
import script from "./SelfUser.vue?vue&type=script&lang=js"
export * from "./SelfUser.vue?vue&type=script&lang=js"
import style0 from "./SelfUser.vue?vue&type=style&index=0&id=b8167446&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports